import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { color } from '../templates/Ui';
import { getAppThemeName } from '../../services/appTheme';
const StyledSelectWrapper = styled.div `
    .react-select__control {
        transition: border-color .2s ease-in-out;
        border-width: 1px;
        border-style: solid;
        border-color: ${color.border.input};
        border-radius: 6px;

        ${props => props.appTheme === 'invoned' &&
    css `
                &--is-focused:hover {
                    border-color: ${color.border.input};
                }

                &--is-focused {
                    box-shadow: none;
                }
            `};

        ${props => props.activeFilter &&
    props.appTheme === 'inkassier' &&
    css `
                border-color: ${props.theme.secondary};
            `};

        ${props => props.appTheme === 'inkassier' &&
    css `
                &:focus {
                    border-color: ${props.theme.secondary};

                    ~ .focus-border {
                        width: 100%;
                    }
                }

                &:hover {
                    border: 1px solid ${props.theme.secondary};
                }

                &--is-focused {
                    border-color: ${props.theme.secondary};
                    box-shadow: none;

                    &:hover {
                        border: 1px solid ${props.theme.secondary};
                    }
                }
            `};

        &:focus {
            border-color: ${color.border.input};

            ~ .focus-border {
                width: 100%;
            }
        }

        .react-select__indicator-separator {
            background-color: ${color.border.input};
            opacity: .4;
        }
    }

    .react-select__placeholder {
        color: rgba(41, 48, 87, 0.25);
    }

    .react-select__option--is-selected {
        background-color: ${props => props.theme.primary.base};
    }
}

.react-select__dropdown-indicator {
    svg {
        fill: ${props => props.theme.primary.base};
    }
}

.react-select__value-container {
    align-items: flex-start;
    flex-direction: column;
    padding: 11px;

    > div {
        min-width: 140px;
        max-width: 100%;
    }

    .react-select__multi-value {
        border-radius: 20px;
        background-color: ${color.gray.light};
    }

    .react-select__multi-value__label {
        font-weight: 700;
        font-size: 13px;
        padding: 7px 0 7px 12px
    }

    .react-select__indicator {
        &:hover,
        &:focus {
            cursor: pointer;

            svg {
                fill: ${props => props.theme.secondary};
            }
        }
    }

    .react-select__multi-value__remove {
        margin-left: auto;

        &:hover,
        &:focus {
            cursor: pointer;
            border-radius: 0 50% 50% 0;
        }

        svg {
            width: 30px;
            height: 20px;
            fill: ${props => props.theme.secondary};
        }
    }
`;
const SelectWrapper = ({ children, activeFilter, ...props }) => (_jsx(StyledSelectWrapper, { activeFilter: activeFilter, ...props, appTheme: getAppThemeName(), children: children }));
export default SelectWrapper;
